import { render, staticRenderFns } from "./MeetingClosureDecisions.vue?vue&type=template&id=41c5a85a&"
import script from "./MeetingClosureDecisions.vue?vue&type=script&lang=js&"
export * from "./MeetingClosureDecisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports